import syncApi from './syncApi';

// Scheduler API client. Reuses the syncApi axios instance purely for the
// base URL + auth interceptors (X-Sync-API-Key / X-User); the scheduler UI
// itself is fully standalone.

export const getSummary = () =>
  syncApi.get('/scheduler/summary').then((r) => r.data);

export const listSchedules = () =>
  syncApi.get('/scheduler/schedules').then((r) => r.data);

export const getSchedule = (id) =>
  syncApi.get(`/scheduler/schedules/${id}`).then((r) => r.data);

export const createSchedule = (payload) =>
  syncApi.post('/scheduler/schedules', payload).then((r) => r.data);

export const updateSchedule = (id, payload) =>
  syncApi.put(`/scheduler/schedules/${id}`, payload).then((r) => r.data);

export const deleteSchedule = (id) =>
  syncApi.delete(`/scheduler/schedules/${id}`).then((r) => r.data);

export const toggleSchedule = (id, enabled) =>
  syncApi.post(`/scheduler/schedules/${id}/toggle`, { enabled }).then((r) => r.data);

export const runScheduleNow = (id) =>
  syncApi.post(`/scheduler/schedules/${id}/run-now`).then((r) => r.data);

export const listScheduleRuns = (id, params) =>
  syncApi.get(`/scheduler/schedules/${id}/runs`, { params }).then((r) => r.data);
